module.exports = __webpack_public_path__ + "static/media/2014_jan_fl_hosp.ca2a4101.jpg";